import { useDecision } from "@optimizely/react-sdk"
import {
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCardTitle,
} from "mdb-react-ui-kit"
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useAnswersAdjustmentsQuery } from "./Answer.state";
import { Loadable } from "../common";
import { useLocation } from "react-router-dom";
import AnswerAdjustmentsView from "./AnswerAdjustmentsView";

const Card = styled(MDBCard)`
  margin: -1.5rem 0 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background: rgba(215, 242, 251, .5);
  font-size: 80%;

  .list-unstyled > li + li {
    margin-top: 12px;
  }

  .card-body .adjustment-list__item .form-outline {
    margin-bottom: 0.5rem;
  }

  .btn {
    font-size: 0.875em;
  }
`;

const CardHeader = styled(MDBCardHeader)`
    padding: .5em .75em;
`

const CardBody = styled(MDBCardBody)`
    padding: .75em .75em;

    .list-unstyled {
        margin-bottom: 0;
    }

    .list-group-item {
        padding: .5em .75em;
    }
`

const CardTitle = styled(MDBCardTitle)`
    margin-bottom: 0;
    margin-top: 12px;
    font-size: 1.25em;
`

const AnswerAdjustments = (props) => {
    const { t } = useTranslation()
    const { id } = props
    const location = useLocation()
    const [decisionAdjustments] = useDecision('adjustments')
    const { data, isFetching } = useAnswersAdjustmentsQuery({ answerId: id })
    const { adjustments: adjustmentsData = [] } = data || {}

    const isStreamPage = (location?.pathname || '').includes('stream')

    const adjustments = adjustmentsData
        .filter(adjustment => {
            if (isStreamPage) {
                return adjustment.impacts_leaderboard
            }

            return true
        })
        .filter(adjustment => {
            return adjustment.answer_id === id
        })

    if (adjustments.length === 0 && !isFetching) {
        return null
    }

    return decisionAdjustments?.enabled
        ? (
            <Loadable loading={isFetching} floating>
                <Card>
                    <CardHeader>
                        <CardTitle>
                            {t(`Judgements`)}
                        </CardTitle>
                    </CardHeader>
                    <CardBody>
                        <ul className="list-unstyled">
                            {
                                adjustments.map(adjustment => {
                                    const {
                                        id: adjustmentId,
                                    } = adjustment
                                    return (
                                        <AnswerAdjustmentsView 
                                            key={adjustmentId} 
                                            answerId={id}
                                            isStreamPage={isStreamPage}
                                            {...adjustment} 
                                        />
                                    )
                                })
                            }
                        </ul>
                    </CardBody>
                </Card>
            </Loadable>
        )
        : null
}

export default AnswerAdjustments